import * as React from "react";
import { Indent } from "../../../sharedComponents/indent/Indent";
import * as styles from "./ActionConfirmation.less";

type ActionConfirmationBtn = {
    action: F<void>;
    text: string;
};

interface ActionConfirmationProps {
    title: string;
    apply: ActionConfirmationBtn;
    cancel: ActionConfirmationBtn;
}

export const ActionConfirmation = (props: ActionConfirmationProps) => {
    const { title, apply, cancel } = props;
    return (
        <div className={styles.confirm}>
            {title}
            <Indent />
            <span onClick={apply.action} className={styles.apply}>
                {apply.text}
            </span>
            <Indent />
            <span onClick={cancel.action} className={styles.cancel}>
                {cancel.text}
            </span>
        </div>
    );
};
